const deFormatter = new Intl.NumberFormat('de-DE');

/**
 * Format a numeric value using German locale (e.g. 25000 → "25.000", 1234.5 → "1.234,5").
 * Returns the original string unchanged if it is not a valid number.
 */
export function formatNumber(value: string | number | boolean | null | undefined): string {
  if (value == null || value === '' || typeof value === 'boolean') return '';

  const num = typeof value === 'number' ? value : Number(value);
  if (isNaN(num)) return String(value);

  return deFormatter.format(num);
}

/**
 * Pad a batch ID with leading zeros to 10 characters (SAP standard).
 * Non-numeric or already-padded values are returned unchanged.
 */
export function formatBatchId(value: string | number | boolean | null | undefined): string {
  if (value == null || value === '' || typeof value === 'boolean') return '';

  const str = String(value).trim();
  if (!/^\d+$/.test(str)) return str;

  return str.padStart(10, '0');
}
